import { tv, type VariantProps } from 'tailwind-variants'

export const image = tv({
  base: 'h-full w-full flex-1',
  variants: {
    radius: {
      none: 'rounded-none',
      sm: 'rounded-sm',
      md: 'rounded-md',
      lg: 'rounded-lg',
      xl: 'rounded-xl',
      '2xl': 'rounded-2xl',
      '3xl': 'rounded-3xl',
      full: 'rounded-full',
    },
    shadow: {
      none: 'shadow-none',
      sm: 'shadow-sm',
      md: 'shadow-md',
      lg: 'shadow-lg',
    },
  },
  defaultVariants: {
    radius: 'lg',
    shadow: 'none',
    isBlurred: false,
    disableAnimation: false,
  },
})

export type TImageVariantProps = VariantProps<typeof image>
